import { Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import { PaymentTransaction } from '../../../types/type';

interface ClaimDetailsPaymentsType {
  paymentInfo?: PaymentTransaction[];
}
export default function ClaimDetailsPayments(props: ClaimDetailsPaymentsType) {
  return (
    <Grid container sx={{ marginTop: '1rem', marginLeft: '1rem', marginBottom: '1rem' }}>
      {props.paymentInfo && props.paymentInfo.length === 0 && (
        <Grid item xs={12}>
          <Typography variant="body1">
            Payments related to third party and/or medical, if applicable, will not show here. Please contact us with
            any questions.
          </Typography>
        </Grid>
      )}
      {props.paymentInfo &&
        props.paymentInfo.length > 0 &&
        props.paymentInfo.map((paymentInfo, index) => (
          <Grid container item xs={12} key={index}>
            <Grid item xs={8}>
              <Typography variant="body1">
                <b>{paymentInfo.PayeeName}</b>
              </Typography>
            </Grid>
            <Grid item container direction="column" xs={4} justifyContent="flex-end" alignItems="flex-end">
              <Grid item sx={{ mr: '4rem' }}>
                <Typography variant="body1">{paymentInfo.Amount}</Typography>
              </Grid>
              <Grid item sx={{ mr: '4rem' }}>
                <Typography variant="body1">{paymentInfo.TransactionDate}</Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
    </Grid>
  );
}
